import {
    HTTP_INTERCEPTORS,
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {inject, Injectable, Provider} from '@angular/core';
import {McsApiService} from '@app/member/dashboard/consent/services/mcs-api.service';
import {EMPTY, Observable} from 'rxjs';
import {ShellService} from "@edifecs/fp-ui-shell";
import {AppConstants} from "@app/AppConstants";

@Injectable()
export class ConsentInterceptor implements HttpInterceptor {

    public static readonly INTERCEPTOR_PROVIDER: Provider = {
        provide: HTTP_INTERCEPTORS,
        multi: true,
        useClass: ConsentInterceptor
    };

    mcsApiService = inject(McsApiService);

    constructor(private readonly shellSvc: ShellService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.includes('/consents/')) {
            return next.handle(req).pipe(catchError((error: HttpErrorResponse) => {
                // fix for CMFA #197 + https://ecbugs.corp.edifecs.com/show_bug.cgi?id=249840
                // now handles both response shapes:
                // old: { errorList: [{ message }] }
                // new: { message }  (flat, e.g. the FHIR mismatch 403)
                const msg = error.error?.errorList?.[0]?.message
                    ?? error.error?.message ?? AppConstants.ERROR_LOADING_DATA;
                this.shellSvc.showToast(msg, {type: 'error'});

                // prevents the error to reach central interceptor
                return EMPTY;
            }));
        }
        return next.handle(req);
    }
}
